export default __webpack_public_path__ + "static/media/pricelocq-logo-white.c0cc2ef7.svg";